/** Синхронные проверки перед закрытием модалки (крестик и т.п.). Вернуть false — закрытие отменить. */
type ModalCloseGuard = () => boolean

const guards: Partial<Record<string, ModalCloseGuard>> = {}

export function setModalCloseGuard(
  modalName: string,
  guard: ModalCloseGuard | null
): void {
  if (guard == null) {
    delete guards[modalName]
    return
  }
  guards[modalName] = guard
}

/** true — закрываем модалку, false — оставить открытой */
export function runModalCloseGuard(modalName: string): boolean {
  const g = guards[modalName]
  if (typeof g !== 'function') {
    return true
  }
  return g() !== false
}
/** Синхронные проверки перед закрытием модалки (крестик и т.п.). Вернуть false — закрытие отменить. */
type ModalCloseGuard = () => boolean

const guards: Partial<Record<string, ModalCloseGuard>> = {}

export function setModalCloseGuard(
  modalName: string,
  guard: ModalCloseGuard | null
): void {
  if (guard == null) {
    delete guards[modalName]
    return
  }
  guards[modalName] = guard
}

/** true — закрываем модалку, false — оставить открытой */
export function runModalCloseGuard(modalName: string): boolean {
  const g = guards[modalName]
  if (typeof g !== 'function') {
    return true
  }
  return g() !== false
}
